<template>
    <div>
        <Breadcrumbs main="Preferences" title="Preference List"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">

              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <!-- <a class="btn btn-primary mr-3 mb-2" v-b-modal.patient >
                                
                                <i class="icon-shopping-car"> </i> New Courier</a
                              > -->
                              <!-- <a hidden class="btn btn-outline-primary mr-3 mb-2" v-b-modal.request >
                                
                                <i class="icon-user"> </i> Patient Request</a
                              >
                              <a  class="btn btn-outline-primary mr-3 " v-b-modal.importPatient >
                                <i class="icon-cloud-up"> </i> Import </a
                              > -->
                              <a  class="btn btn-primary mr-3 ">
                                <i class="icon-cloud-down"> </i> Export </a
                              >
                            </div>

                          </b-col>
                      </b-row>


                      <b-modal id="shopModal" size="lg" ref="shopModal" :title="'View Shop Profiles : '+shopTitle" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="shopTable"
                                :items="allShops"
                                :fields="shopfields"
                                :per-page="perShopPage"
                              >
                                  <template #cell(shop)="row">
                                    <span style="font-weight:500;" class="txt-primary">
                                      {{ row.item.shop }}
                                    </span>
                                </template>
                                
                                <template #cell(user)="row">

                                  <a style="font-weight:500" :href="`tel:${row.item.user.countryCode+row.item.user.tel}`" class="txt-primary">
                                      {{ row.item.user.countryCode+row.item.user.tel }}
                                    </a>
                                </template>

                                <template #cell(preferences)="row">

                                    <div class="btn btn-primary btn-xs btn-pill mr-3" v-for="pref in row.item.preferences" :key="pref">
                                        {{ pref }}
                                    </div>

                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                              </b-table>
                            </b-modal>

                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          :items="items"
                          :fields="tablefields"
                          :select-mode="selectMode"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(action)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <b-dropdown-item @click="shops(row.item)">Shop Profiles</b-dropdown-item>
                              <b-dropdown-item @click="alert(row.item)">Alert</b-dropdown-item>
                              <!-- <b-dropdown-item @click="edit(row.item)">Edit</b-dropdown-item> -->
                              <!-- <b-dropdown-item @click="view(row.item)">View </b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="addcomment(row.item)">Add comment</b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="viewcomment(row.item.fullname, row.item.tel)">View comment</b-dropdown-item> -->
                              <!-- <b-dropdown-divider></b-dropdown-divider> -->
                              <!-- <b-dropdown-item @click="del(row.index)">Delete </b-dropdown-item> -->
                          </b-dropdown>
                          </template>

                          <template #cell(gender)="row">
                            <div class="btn btn-info btn-xs btn-pill mr-3">
                                {{ row.item.gender }}
                            </div>
                        </template>
                    

                          <template #cell(preferences)="row">

                                <div class="btn btn-primary btn-xs btn-pill mr-2 mb-2" v-for="pref in row.item.preferences" :key="pref">
                                        {{ pref }}
                                </div>

                            </template>

                          <template #cell(phone)="row">

                            <a style="font-weight:500" :href="`tel:${row.item.phone.countryCode+row.item.phone.tel}`" class="txt-primary">
                                {{ row.item.phone.countryCode+row.item.phone.tel }}
                              </a>
                          </template>

                          <template #cell(dob)="row">
                                {{ row.item.dob ? new Date(row.item.dob).toDateString().substr(4) : '' }}
                          </template>

                          <template #cell(points)="row">

                            <span style="font-weight:500" class="txt-primary">
                                {{ row.item.points.length > 0 ? parseFloat(row.item.points.reduce((a, b) => a + b.point, 0) ) : 0  }}

                            </span>
                          </template>

                          <template #cell(createdAt)="row">
                                {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }}
                          </template>
                        </b-table>
                        
                      </div>

                      <p>{{ totalRows.length }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
// import Multiselect from 'vue-multiselect'

export default {
  data(){
    return{
      singledropzoneOptions:{
          url:"http://localhost:8080/uploadpatient",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      requestLoading: false,
      submitting: false,
      categorySelect: true,
      typeSelect: true,
      codeData: {},
      shopTitle: '',
      statusOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      tablefields: [
        { key: 'name', label: 'Customer Name', sortable: true, },
        { key: 'gender', label: 'Gender', sortable: true, },
        { key: 'phone', label: 'Contact', sortable: false, },
        { key: 'preferences', label: 'Preferences', sortable: true, },
        { key: 'dob', label: 'DateofBirth', sortable: true, },
        { key: 'Points', label: 'Points', sortable: true, },
        // { key: 'active', label: 'Status', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: true, },
        // { key: 'action', label: 'Action', sortable: false, },
      ],
      shopfields: [
        { key: 'shop', label: 'Shop', sortable: true, },
        { key: 'preferences', label: 'Feedback', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      items: [],
      allShops: [],
      modes: ['multi', 'single', 'range'],
      filter: null,
      sortBy: 'createdAt',
      sortDesc: true,
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
      sortProductBy: 'product',
      currentProductPage: 1,
      totalProductRows: 1,
      perProductPage: 5,
      totalShopRows: 1,
      perShopPage: 5,
    }
  },
  components: {
    
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    userAdmin() {
      return localStorage.getItem('type') == "admin" ? true : false
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
      },
      { immediate: true }

    )

  },
  watch: {
    dropFile() {
        if (this.dropFile !== null ){
            this.img = window.URL.createObjectURL(this.dropFile)    
        }

        if (this.dropFile == null) {
            window.URL.revokeObjectURL(this.img)
        }
    },
    productFile() {
        if (this.productFile !== null ){
            this.pro = window.URL.createObjectURL(this.productFile)    
        }

        if (this.productFile == null) {
            window.URL.revokeObjectURL(this.pro)
        }
    }
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
  },
  methods: {
    fetchData() {

     const url = this.userAdmin ? '/pref/' : '/pref/'+this.$store.getters['authentication/getUser'].name

      axios.get(url)
        .then(response=>{
          //
          this.items = response.data
          this.totalRows = this.items.length

          for (let index = 0; index < this.items.length; index++) {

                // date
                if (this.items[index].createdAt) {
                  this.items[index].date = (new Date(this.items[index].createdAt)).toDateString().substring(4)
                
                }

                const shop = this.items[index].shops.find(shop => shop.shop == this.$store.getters['authentication/getUser'].name)

                if (shop) {
                  this.items[index].preferences = shop.preferences
                }
            }
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })

        // axios.get('/vendor')
        // .then(response=>{
        //   //
        //   //   this.items = response.data
        //   const vendors = response.data.map(vendor => vendor.business)
        //   this.vendorOptions = []
        //   //   this.vendorOptions  = [...new Set(vendors)]
        // //   const vendorList = []
          
        //   for (let index = 0; index < vendors.length; index++) {
        //     const value = { code: vendors[index], name: vendors[index] };
        //     this.vendorOptions.push(value)
        //   }
        //   console.log(this.vendorOptions)
          
        // })
        // .catch( e => {
        //   this.$swal({
        //     title:"Failed!",
        //     text:e.response.data,
        //     type:'error'
        //   });
        // })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    shops(data) {
        // modal
        this.$refs.shopModal.show()
        //
        this.shopTitle = data.name

        //
        // axios.get('/order/'+data.business).then( response=>{
            let _shop = this.$store.getters['authentication/getUser'].name

            //
            this.allShops = this.userAdmin ? data.shops : data.shops.filter(shop => shop.shop == _shop)
            this.totalShopRows= this.userAdmin ? data.shops.length : data.shops.filter(shop => shop.shop == _shop).length

        // }).catch(error=>{

        //     console.log(error.response.data)
        // })

    },
    view(data){
      // modal
      this.$refs.viewvendorModal.show()

      this.viewVendor = data
      //
    },
    onSelect({name, iso2, dialCode}) {
        // this.form.code = "+"+dialCode
        this.vendor.country.name = name.split("(")[0].trim()
        this.vendor.country.currency = dialCode == "233" ? iso2+"₵" : iso2
        this.vendor.country.code = "+"+dialCode
        this.vendor.phone.countryCode = "+"+dialCode
        console.log(name, iso2, dialCode);
    },
    switchCategory() {
        this.categorySelect = this.categorySelect ? false : true
    },
    switchType() {
        this.typeSelect = this.typeSelect ? false : true
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}

.loader-box [class*="loader-"] {
    width: 30px;
    height: 30px;
}
</style>